import { useEffect, useState } from 'react';
import { Container, Card, Note, Info, Tag } from './styled';
import { DatePicker } from '../../components';
import { BsHeadset } from 'react-icons/bs';
import { BiSearchAlt } from 'react-icons/bi';
import { maskZero, maskDate } from '../../utils';
import { getCloseCustomer } from '../../service/serviceChat/customerService';
import { useChat } from '../../contexts/chat';
import moment from 'moment';


export function HistoricClient(props) {

    const { client } = props;
    const { accessLevel, idUser } = useChat();

    const [customerService, setCustomerService] = useState([]);
    const [dateStart, setDateStart] = useState(moment(`${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`).format('YYYY-MM-DD'));
    const [dateEnd, setDateEnd] = useState(moment(`${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`).format('YYYY-MM-DD'));


    async function searchHistoricClient() {
        const data = await getCloseCustomer(0, client.client_id, !accessLevel?.includes('TODOS_FECHADOS') ? idUser : 0, moment(dateStart).format('DD/MM/YYYY'), moment(dateEnd).format('DD/MM/YYYY'));
        setCustomerService([...data])
    }
    useEffect(() => {
        searchHistoricClient();
    }, []);

    return (
        <Container>
            <div className='filter--'>
                <DatePicker className="date" value={dateStart} onChange={setDateStart} />
                <span> - </span>
                <DatePicker className="date" value={dateEnd} onChange={setDateEnd} />
                <span className='icon--' onClick={() => searchHistoricClient()}>
                    <BiSearchAlt />
                </span>
            </div>
            {customerService?.map((item) =>
                <Card key={item.id}>
                    <Note>
                        <p>
                            {`👤 ${item?.client_name}`}
                        </p>
                    </Note>
                    <Note>
                        <p>{`📞 ${item?.client_phone}`}</p>
                    </Note>
                    <Info>
                        <Tag type='inFo'>
                            <p>{maskZero(item?.id)}</p>
                        </Tag>
                        <Tag type='name'>
                            <span><BsHeadset /></span>
                            <p>{item?.usuario_login}</p>
                        </Tag>
                        <Tag type='inFo'>
                            <p>{maskDate(item?.started_at) + ' - ' + moment(item?.started_at).format('HH:mm')}</p>
                        </Tag>
                        <Tag type='inFo'>
                            <p>{item?.finished_at ? maskDate(item?.finished_at) + ' - ' + moment(item?.finished_at).format('HH:mm') : 'Aberto'}</p>
                        </Tag>
                    </Info>
                </Card>
            )}
        </Container>
    );
}